import { render, staticRenderFns } from "./Poste.vue?vue&type=template&id=184fff90&"
import script from "./Poste.vue?vue&type=script&lang=js&"
export * from "./Poste.vue?vue&type=script&lang=js&"
import style0 from "./Poste.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports